import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import ReactTooltip from 'react-tooltip';
import { ModalDialog } from '../modal_dialog';
import { ModalDialogCommon } from '../modal_dialog_common';
import Modal from 'react-modal';


import { validate } from '../../validations';
import Header from '../../components/header';
let screenIdentifier = 'facilities_add';
import InputMask from 'react-input-mask';

export var NewfacilityHeader = React.createClass({
  render() {
    return (
      <div className="start-facility">
        <span className="icon-blue-arrow"></span>
        <p className="admin-text">Hi  !</p>
        <p className="add-facility-text">Let’s start adding a clinic.</p>
        <p className="fill-info">Please fill the information below to add clinic.</p>
      </div>
    )
  }
})

export var Addfacility = React.createClass({
  getInitialState() {
    return {
      dialog: false,
      // isNewFacility: false,
      isImageUploaded: false,
      fileUploaded: null,
      loader: false,
      zipCssClass: "inputText",
      mobileCssClass: "inputText",
      deskNumberCssClass: "inputText",
      isFormSubmited: null,
    }
  },

  componentWillMount() {
    // window.location.hash === "#new" ? this.setState({ 'isNewFacility': true }) : this.setState({ 'isNewFacility': false })
  },

  componentWillReceiveProps(nextProps) {

    // Create facility response
    if (this.state.isFormSubmited) {
      this.setState({ isFormSubmited: null })
      if (nextProps.FacilitiesDetails.FaciliteCreateDeatils ? nextProps.FacilitiesDetails.FaciliteCreateDeatils.status == 200 : false) {
        nextProps.FacilitiesDetails.FaciliteCreateDeatils.status = null;
        this.setState({ "loader": false, dialog: true });
      } else {
        this.setState({ loader: false, Okmessage: nextProps.FacilitiesDetails.FaciliteCreateDeatils.message });
      }
    }

    // Facility image upload response
    if (nextProps.FacilitiesDetails.FacilityImageUpload && nextProps.FacilitiesDetails.FacilityImageUpload.status == 200) {
      nextProps.FacilitiesDetails.FacilityImageUpload.status = null;
      this.setState({ isImageUploaded: true });
    }
    else {
      this.setState({ isImageUploaded: false });
    }

  },

  email_validate(event) {
    validate.email(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  phone_validate(event) {
    validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  alternate_phone_validate(event) {
    if (event.target.value.trim().length) {
      validate.phone(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    }
  },

  zipcode_validate(event) {
    validate.zipCode(event.target.value.trim()) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  url_validate(event) {
    let url = event.target.value.trim();
    if (url.length > 0) {
      validate.website(url) ? event.target.className = 'inputText' : event.target.className = 'inputText error';
    }
  },

  no_empty(event) {
    event.target.value.trim().length > 0 ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  addFacility() {
    this.setState({ Okmessage: null, isFormSubmited: null });

    let maxNoOfStaff = this.refs['maxNoOfStaff'],
      maxNoOfPatient = this.refs['maxNoOfPatient'],
      maxNoOfAdmin = this.refs['maxNoOfAdmin'];

    //validation for name
    let isValidName = validate.name(this.refs['name']);
    isValidName ? this.refs.name.className = 'inputText' : this.refs.name.className = 'inputText error';

    //validation for Email
    let isValidEmail = validate.email(this.refs['email'].value.trim());
    isValidEmail ? this.refs.email.className = 'inputText' : this.refs.email.className = 'inputText error';

    //validation for mobile
    let isValidmobile = validate.phone(this.refs.mobile.state.value);
    !isValidmobile ? this.setState({ mobileCssClass: "inputText error" }) : this.setState({ mobileCssClass: "inputText" });

    //validation for desk number
    let isAltenatePhoneAvailable = null;
    let isValidDeskNumber = null;
    if (this.refs.deskNumber.state.value.trim().length) {
      isAltenatePhoneAvailable = true;
      isValidDeskNumber = validate.phone(this.refs.deskNumber.state.value);
      !isValidDeskNumber ? this.setState({ deskNumberCssClass: "inputText error" }) : this.setState({ deskNumberCssClass: "inputText" });
    }

    //validation for Url
    let isValidwebsiteUrl = null,
      Url = this.refs.url.value.trim();
    if (Url.length > 0) {
      isValidwebsiteUrl = validate.website(Url);
      !isValidwebsiteUrl ? this.refs.url.className = "inputText error" : this.refs.url.className = "inputText";
    } else {
      this.refs.url.className = "inputText";
    }

    // validation for Street
    let isValidstreet = validate.name(this.refs['street']);
    isValidstreet ? this.refs.street.className = 'inputText' : this.refs.street.className = 'inputText error';

    //validation for city
    let isValidCity = validate.name(this.refs['city']);
    isValidCity ? this.refs.city.className = 'inputText' : this.refs.city.className = 'inputText error';

    // validation for State
    let isValidState = validate.name(this.refs['state']);
    isValidState ? this.refs.state.className = 'inputText' : this.refs.state.className = 'inputText error';

    // validation for Country
    let isValidCountry = validate.name(this.refs['country']);
    isValidCountry ? this.refs.country.className = 'inputText' : this.refs.country.className = 'inputText error';

    //validation for zip code
    let isValidZipCode = validate.zipCode(this.refs.zipCode.state.value);
    isValidZipCode && !(this.refs.zipCode.state.value <= 0) ? this.setState({ zipCssClass: "inputText" }) : this.setState({ zipCssClass: "inputText error" });

    //validation for max admin
    let isValidMaxAdmin = validate.onlyNum(maxNoOfAdmin.value) && (maxNoOfAdmin.value <= 99 && maxNoOfAdmin.value > 0);
    isValidMaxAdmin ? maxNoOfAdmin.className = "inputText" : maxNoOfAdmin.className = "inputText error";

    //validation for max staff
    let isValidMaxStaff = validate.onlyNum(maxNoOfStaff.value) && (maxNoOfStaff.value <= 999 && maxNoOfStaff.value > 0);
    isValidMaxStaff ? maxNoOfStaff.className = "inputText" : maxNoOfStaff.className = "inputText error";

    //validation for max Patient
    let isValidMaxPatient = validate.onlyNum(maxNoOfPatient.value) && (maxNoOfPatient.value <= 99999 && maxNoOfPatient.value > 0);
    isValidMaxPatient ? maxNoOfPatient.className = "inputText" : maxNoOfPatient.className = "inputText error";
    // To Check each field empty or not
    if (this.refs.name.value.trim().length === 0 || this.refs.email.value.trim().length === 0 || this.refs.street.value.trim().length === 0 || this.refs.city.value.trim().length === 0 || this.refs.state.value.trim().length === 0 || this.refs.country.value.trim().length === 0 || this.refs.zipCode.state.value.trim().length === 0 || this.refs.mobile.state.value.length === 0 || this.refs.maxNoOfStaff.value.trim().length === 0 || this.refs.maxNoOfPatient.value.trim().length === 0 || this.refs.maxNoOfAdmin.value.trim().length === 0) {
      this.setState({ Okmessage: 'Please enter necessary fields to proceed.' });
      return false;
    }

    if (isValidName && isValidEmail && isValidmobile && (isAltenatePhoneAvailable ? isValidDeskNumber : true) && (Url.length > 0 ? isValidwebsiteUrl : true) && isValidstreet && isValidCity && isValidState && isValidCountry && isValidZipCode && validate.onlyNum(maxNoOfAdmin.value) && validate.onlyNum(maxNoOfStaff.value) && validate.onlyNum(maxNoOfPatient.value)) {
      if (!isValidMaxAdmin) {
        this.setState({ Okmessage: "Admin count should be greater than 0 and less than 99." })
        return false;
      }
      else if (!isValidMaxStaff) {
        this.setState({ Okmessage: "Staff count should be greater than 0 and less than 999." })
        return false;
      }
      else if (!isValidMaxPatient) {
        this.setState({ Okmessage: "Patient count should be greater than 0 and less than 99999." })
        return false;
      }
    }
    else {
      this.setState({ Okmessage: 'Please enter valid information to proceed.' });
      return;
    }

    if (isValidName && isValidEmail && isValidmobile && (isAltenatePhoneAvailable ? isValidDeskNumber : true) && (Url.length > 0 ? isValidwebsiteUrl : true) && isValidstreet && isValidCity && isValidState && isValidCountry && isValidZipCode && isValidMaxAdmin && isValidMaxStaff && isValidMaxPatient) {
      var data = {};
      data.name = this.refs['name'].value.trim();
      data.email = this.refs['email'].value.trim();
      data.mobile = this.refs.mobile.state.value.replace(/ /g, "");
      if (isValidDeskNumber) {
        data.deskNumber = this.refs.deskNumber.state.value.replace(/ /g, "");
      }
      data.url = this.refs['url'].value.trim();

      data.address = {
        "street": this.refs['street'].value.trim(),
        "city": this.refs['city'].value.trim(),
        "state": this.refs['state'].value.trim(),
        "country": this.refs['country'].value.trim(),
        "zipCode": this.refs['zipCode'].state.value.trim(),
      }
      if (this.state.isImageUploaded && this.props.FacilitiesDetails.FacilityImageUpload.data) {
        data.imageUrl = this.props.FacilitiesDetails.FacilityImageUpload.data;
      }
      data.createdBy = { "id": this.props.UserDetails.selectedUserRoleID};

      data.maxNoOfAdmin = this.refs['maxNoOfAdmin'].value.trim();
      data.maxNoOfStaff = this.refs['maxNoOfStaff'].value.trim();
      data.maxNoOfPatient = this.refs['maxNoOfPatient'].value.trim();

      this.setState({ isFormSubmited: true });
      this.props.Dispatch(FacilitiesActions.createfacility(data));
      this.setState({ loader: true });

    } else {
      this.setState({ Okmessage: 'Please enter valid information.' });
    }


  },

  closebox() {
    this.setState({ Okmessage: false });
  },

  remove_error(event) {
    event.target.className = 'inputText';
  },

  add_admin() {
    this.props.router.push('/facilities/admin/add#new');
    document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
  },
  add_admin_later() {
    this.setState({ 'dialog': false });
    this.props.router.push('/facilities');
    document.body.scrollTop = document.documentElement.scrollTop = 0; // to scroll to top in samll screen
  },

  isValidMaxAdmin(event) {
    let isValidMaxAdmin = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 99 && event.target.value.trim() > 0);
    isValidMaxAdmin ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  isValidMaxStaff(event) {
    let isValidMaxStaff = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 999 && event.target.value.trim() > 0);
    isValidMaxStaff ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  isValidMaxPatient(event) {
    let isValidMaxPatient = validate.onlyNum(event.target.value.trim()) && (event.target.value.trim() <= 99999 && event.target.value.trim() > 0);
    isValidMaxPatient ? event.target.className = 'inputText' : event.target.className = 'inputText error';
  },

  cancel() {
    this.props.router.goBack();
  },

  uploadFacilityImage(e) {

    // if User doesn't select(if he click on cancle) any image
    //To check if user upload any file
    if (e.target.files.length === 0) {
      return;
    }

    var fuData = e.target.files[0];
    var FileUploadPath = fuData.name;
    var size = fuData.size;

    //To check the uploaded file is an image
    var Extension = FileUploadPath.substring(FileUploadPath.lastIndexOf('.') + 1).toLowerCase();
    if (Extension == "png" || Extension == "jpeg" || Extension == "jpg") {

      if (size < 2097152) {
        var files = e.target.files || e.dataTransfer.files;
        var imageData = new FormData();
        let file = files[0];
        this.setState({ fileUploaded: file.name });
        imageData.append("file", e.target.files[0]);
        this.props.Dispatch(FacilitiesActions.uploadFacilityImage(imageData));
      }
      else {
        e.target.value = "";
        this.setState({ Okmessage: "Please select an image that is less than 2MB.", dialog: false });
      }

    }
    else {
      this.setState({
        Okmessage: "Only photos with extension .png, .jpg, .jpeg are allowed.",
        dialog: false
      })
    }
  },
  render() {
    var self = this;
    return (
      <div className="dashboard-inner-content">
        <Header loader={this.state.loader} screenIdentifier={screenIdentifier} />
        <NewfacilityHeader />
        <div className="white-box">
          <div className="create-facility">

            <div className="row">


              <div className="col-xs-6 no-padding facility-details">
                <h4>Clinic details</h4>

                <div className="input-group">
                  <input type="text" className="inputText" ref="name" maxLength="64" onFocus={this.remove_error} onBlur={this.no_empty} required />
                  <span className="floating-label">Clinic Name</span>
                </div>
                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" onFocus={this.remove_error} onBlur={this.email_validate} ref="email" required />
                  <span className="floating-label">Email</span>
                </div>
                <div className="input-group">
                  <InputMask type="text" className={this.state.mobileCssClass} onFocus={this.remove_error} onBlur={this.phone_validate} ref="mobile" required mask="999 999 9999" maskChar={null}></InputMask>
                  <span className="floating-label" >Primary Phone</span>
                </div>
                <div className="input-group">
                  <InputMask type="text" className={this.state.deskNumberCssClass} onFocus={this.remove_error} onBlur={this.alternate_phone_validate} ref="deskNumber" required mask="999 999 9999" maskChar={null}></InputMask>
                  <span className="floating-label" >Alternate Phone </span>
                </div>

                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" ref="url" onFocus={this.remove_error} onBlur={this.url_validate} required />
                  <span className="floating-label">Website</span>
                </div>
                <div className="input-group">
                  <div className="facility-upload">
                    <p>
                      <label className="uploadBtn gray-button" htmlFor="upload">Upload Clinic image</label>
                      <input type="file" id="upload" ref="facilityImageUrl" onChange={this.uploadFacilityImage} onFocus={this.remove_error} required />
                      <span>{this.state.fileUploaded && this.state.fileUploaded} </span>
                    </p>
                  </div>
                </div>

              </div>
              <div className="col-xs-6 no-padding facility-details address">
                <h4>Address</h4>
                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" onFocus={this.remove_error} onBlur={this.no_empty} ref="street" required />
                  <span className="floating-label">Street</span>
                </div>
                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" onFocus={this.remove_error} onBlur={this.no_empty} ref="city" required />
                  <span className="floating-label">City</span>
                </div>
                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" onFocus={this.remove_error} onBlur={this.no_empty} ref="state" required />
                  <span className="floating-label">State</span>
                </div>
                <div className="input-group">
                  <input type="text" className="inputText" maxLength="64" onFocus={this.remove_error} onBlur={this.no_empty} ref="country" required />
                  <span className="floating-label">Country</span>
                </div>
                <div className="input-group">
                  <InputMask type="text" className={this.state.zipCssClass} onFocus={this.remove_error} onBlur={this.zipcode_validate} ref="zipCode" maxLength="5" mask="99999" maskChar={null} required />
                  <span className="floating-label">Zip</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12 no-padding">
              <div className="set">
                <h4>Set User Limit <img className="question-markimage" data-tip="<div><p>Maximum number of Admin : 99</p><p>Maximum number of Staff : 999</p>
<p>Maximum number of Patients : 99999</p></div>" data-html={true}src={require('./../../images/question-icon.png')}/></h4>
          </div>
        </div>
      </div>
      <ReactTooltip html={true} />
      <div className="row">
        <div className="col-xs-11 user-limit no-padding">
          <div className="col-xs-4 no-padding">
            <div className="input-group ">
              <input type="text" className="inputText" onBlur={this.isValidMaxAdmin} onFocus={this.remove_error} ref="maxNoOfAdmin" required maxLength="2" />
              <span className="floating-label">Mobi Admin</span>
            </div>
          </div>
          <div className="col-xs-4 no-padding">
            <div className="input-group">
              <input type="text" className="inputText" onBlur={this.isValidMaxStaff} onFocus={this.remove_error} ref="maxNoOfStaff" required maxLength="3" />
              <span className="floating-label">Staff</span>
            </div>
          </div>
          <div className="col-xs-4 no-padding">
            <div className="input-group">
              <input type="text" className="inputText" onBlur={this.isValidMaxPatient} onFocus={this.remove_error} ref="maxNoOfPatient" required maxLength="5" />
              <span className="floating-label">Patients</span>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 no-padding">
          <button className="gray-button create-facility-button margin-right-10" onClick={this.addFacility}> Add New Clinic</button>
          {window.location.hash != "#new" ? <button className="gray-button create-facility-button" onClick={this.cancel}> Cancel </button> : ""}
        </div>
      </div>

      <div className="row">
        <div className="col-xs-12 no-padding">
          <div> {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}</div>
          <div> {this.state.dialog ? <ModalDialog addadmin={this.add_admin} doitlater={this.add_admin_later} /> : ""}

          </div>
        </div>
      </div>

        </div >
      </div >


    );
  }
});


let mapStateToProps = (state) => {
  return {
    UserDetails:state.User,
    FacilitiesDetails: state.Facilites,
    LogingDetails: state.User.loginData,
  };
};

let mapDispatchToProps = (dispatch) => ({
  FacilitiesActions: bindActionCreators(FacilitiesActions, dispatch),
  Dispatch: dispatch
});
export default connect(mapStateToProps,
  mapDispatchToProps)(withRouter(Addfacility));



/** WEBPACK FOOTER **
 ** ./src/components/facilitiesScreen/add-facility.js
 **/